/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  GET_CURRENT_FILTER,
  SET_CURRENT_FILTER,
} from "../actions/auth/authActionTypes";
import { dateFilters } from "../helpers/constants";

const initialState = {
  currentFilter: dateFilters.find((f) => f._id === "last_12_months"),
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_FILTER:
      return {
        ...state,
        currentFilter: action.payload,
      };
    case GET_CURRENT_FILTER:
      return state;
    default:
      return state;
  }
}
